import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

const HEIGHTS = [30, 48, 66, 48, 30] as const;

export function AnalyticsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="28"
        y="26"
        width="104"
        height="104"
        rx="12"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="60" y="36" width="40" height="6" rx="3" fill={c.p200} />
      {HEIGHTS.map((h, i) => (
        <rect
          key={i}
          x={34 + 20 * i}
          y={116 - h}
          width="12"
          height={h}
          rx="4"
          fill={i === 2 ? c.a400 : c.p400}
        />
      ))}
      <rect x="34" y="116" width="92" height="3" rx="1.5" fill={c.p200} />
    </Frame>
  );
}
